export var Theme;
(function (Theme) {
    Theme["PRESET01"] = "preset01";
    Theme["PRESET02"] = "preset02";
    Theme["PRESET03"] = "preset03";
    Theme["PRESET04"] = "preset04";
    Theme["PRESET05"] = "preset05";
    Theme["PRESET06"] = "preset06";
    Theme["PRESET07"] = "preset07";
    Theme["PRESET08"] = "preset08";
    Theme["PRESET09"] = "preset09";
    Theme["PRESET10"] = "preset10";
    Theme["PRESET11"] = "preset11";
    Theme["PRESET12"] = "preset12";
    Theme["PRESET13"] = "preset13";
    Theme["PRESET14"] = "preset14";
    Theme["PRESET15"] = "preset15";
    Theme["PRESET16"] = "preset16";
    Theme["PRESET17"] = "preset17";
    Theme["PRESET18"] = "preset18";
    Theme["PRESET19"] = "preset19";
    Theme["PRESET20"] = "preset20";
    Theme["ADI_DARK_01"] = "adi-dark-01";
    Theme["ADI_DARK_02"] = "adi-dark-02";
    Theme["ADI_LIGHT_01"] = "adi-light-01";
    Theme["ADI_LIGHT_02"] = "adi-light-02";
})(Theme || (Theme = {}));
//# sourceMappingURL=form-style.js.map